import { render, staticRenderFns } from "./change-password-overlay.vue?vue&type=template&id=145e0e70"
import script from "./change-password-overlay.vue?vue&type=script&lang=js"
export * from "./change-password-overlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports